import { configsInfo } from './allConfigs'

/**
 * @see { configsInfo } // You should not edit this. Edit inside ./allConfigs only.
 * @param { notStored } // Argument to decide if we should get MID & UserId from localstorage or not.
 * @returns { Object } returns an object with simple key and value, the value is coming from val in each key in allConfigs
 */
export const initialConfig = (notStored) => {
  const configs = {}
  const allConfigs = configsInfo(notStored)
  for (const config in allConfigs) {
    configs[config] = allConfigs[config].val
  }
  return configs
}
